/**
 * Build a string describing the path.
 */
export default function printPathArray(path) {
  return path.map(function (key) {
    return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
  }).join('');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/jsutils/printPathArray.mjs
// module id = 584
// module chunks = 4